import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import { trackEvent } from '@/utils/analytics';
import { cn } from '@/lib/utils';
import { CalendarPreviewSlice } from './calendar/CalendarPreviewSlice';
import { HERO_PREMIUM_COPY } from './heroPremiumCopy';

const trackPremiumPointer = () => {
  try { trackEvent('hero_cta_click', { cta: 'premium_pointer' }); } catch { /* never block */ }
};

const pointerClass =
  'inline-flex items-center justify-center gap-2 border border-gold text-gold hover:bg-gold ' +
  'hover:text-primary-foreground font-semibold rounded-[4px] transition-colors text-sm whitespace-nowrap ' +
  'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-gold focus-visible:ring-offset-2 focus-visible:ring-offset-navy';

export const HeroPremiumPreview: React.FC = () => (
  <aside aria-label="Calendar preview and Premium" className="hidden lg:block rounded-lg border border-white/15 bg-navy/60 p-3">
    <div className="flex items-baseline justify-between gap-3 mb-2">
      <p className="text-xs font-medium text-white/75">{HERO_PREMIUM_COPY.caption}</p>
      <p className="text-xs text-white/75 whitespace-nowrap">
        <span className="font-semibold text-white">{HERO_PREMIUM_COPY.priceAmount}</span>
        {HERO_PREMIUM_COPY.pricePeriod}
      </p>
    </div>
    <CalendarPreviewSlice />
    <div className="mt-4">
      <Link to="/features" onClick={trackPremiumPointer} className={cn(pointerClass, 'w-full px-4 py-2')}>
        {HERO_PREMIUM_COPY.pointerDesktop} <ArrowRight className="w-4 h-4" aria-hidden="true" />
      </Link>
    </div>
  </aside>
);

/** Below lg: compact pointer only. No table slice (the planner's real mobile layout is cards, not a table). */
export const HeroPremiumPointerRow: React.FC = () => (
  <div className="lg:hidden flex items-center gap-3">
    <Link to="/features" onClick={trackPremiumPointer} className={cn(pointerClass, 'min-h-11 px-3 py-1.5 gap-1.5')}>
      {HERO_PREMIUM_COPY.pointerMobile} <ArrowRight className="w-4 h-4" aria-hidden="true" />
    </Link>
  </div>
);
